<template>
  <div id="appMain" class="container">
    <a ref="theory"></a>
    <div class="title"> 产品核心价值和理论基础 </div>
    <hr ref="effect">
    <div class="p">首先说明这篇文章不是关于软件的使用说明，也不是关于软件的架构说明，它阐述了软件的核心价值和理论基础。通过阅读本篇文章，你可以了解阿敦软件会给第三方服务提供商企业何种价值，为什么会实现这种价值，为什么更加适合第三方服务提供商企业，另外文章还会介绍阿敦软件针对第三方服务提供商企业的一些独有的特点。希望本篇文章能够帮助读者做出是否使用阿敦软件的决定。
    </div>
    <div class="h2">蔡格尼克效应</div>
    <div class="p">让我们以一个故事为开端，这个故事奠定了阿敦软件的理论基础。这是一个心理学家卢玛·蔡格尼克（Bluma Zeigarnik）亲身经历的一个事情，也许我们很多人都有过类似的经历。据说，她和同事一起去吃午饭，看到服务员不需要做任何记录，就能准确地记住谁点了什么菜，她为此深感佩服。但令她惊讶的是，当她返回餐厅拿她留在那里的外套时，她崇拜的具有超强记忆力的服务员却不认识她了。蔡格尼克对此很不解，服务员解释说，他们服务员都能记住哪位顾客点了哪些饭菜，但在客人离开餐厅的那一瞬间，他们就把这些全都忘掉，然后把注意力转移到下一拨顾客。
这个现象现在被称之为“蔡格尼克效应”，即未完成的任务往往会占据我们的短期记忆，直到它们被完成为止。这也说明了为什么我们的注意力很容易被未完成任务的想法所干扰，而不管这些想法的重要性如何。
    </div>
    <div class="p">对“蔡格尼克效应”继续探究，我们还发现，其实我们并不一定要完成任务才能说服我们的大脑停止思考它们，我们可以把任务记录下来，让大脑相信它会在之后被妥善处理，至于任务是否是真的完成了，还是通过记录而推迟了，大脑并不会区分。通过记录任务，可以把想法从脑海中逐渐清除出去。</div>
    <div class="p">与“蔡格尼克效应”相关的另一个理论是关于大脑资源的，我们的大脑一次只能专注于一件事，一次最多只能容纳七件事的短期记忆，还有一种有限的资源是驱动力或意志力。我们原本以为是一种性格特征的意志力，其实它如同肌肉，是一种消耗的快而恢复的慢的有限资源。</div>
    <div class="p">阿敦软件可以帮助企业建立一个可靠的、标准化的工作流程，这对我们的注意力、专注力和意志力的消耗都比较小。众所周知，决策是最令人疲惫和厌倦的工作之一，这就是为什么扎克伯格拥有完全相同的灰色T恤，因为这样可以让他早上少做一个决定，把更多的决策力资源留给真正重要的事情。</div>
    <div class="h2">什么是第三方服务提供商？</div>
    <div ref="detail" class="p">企业为维持核心能力将组织的非核心业务委托给外部的专业公司，降低营运成本，集中人力资源和设备满足市场需求。这里的第三方服务提供商就是指接受此类业务委托的企业，它的客户就是上游进行业务外包的企业。
这类企业往往缺少国资背景，难以获得银行贷款支持，另一方面行业竞争十分激烈，因此企业会非常重视投资回报率，他们通常会<b>立足于改善现状，而着眼于未来发展</b>。
</div>
    <div class="h2">改善第三方服务提供商企业现状</div>
    <div class="p"><b>现状一：</b>项目负责人Tiger每天都会接听来自客户的电话，问询关于项目的进展情况，需要多久可以完成或者是否能够按时完成，项目现在进展的什么阶段，项目是否遇到任何问题等等。</div>
    <div class="p">Tiger每次接听都感到头皮发麻，因为他要花很多时间去查询客户项目信息，何时外包，项目预期完成时间，紧急程度如何，此外项目目前停留在什么阶段是他最难以回答的问题，因为有些项目是跨部门的，甚至他自己也不清楚。</div>
    <div class="p">特别另他感到不安的是，如果这次没能明确回答客户的询问，客户的询问频率会增加，询问的内容也会越来越详细。Tiger几乎要崩溃了。</div>
    <div class="p"><b>现状二：</b>Tiger作为项目负责人在接受来自客户的外包任务后，首先要手工填写外包任务信息，而这些任务信息还需要在任务流转表，工单表重复填写；另外Tiger要根据客户要求给出任务完成时间，有的是普通五天的任务，有加急的三天任务，还有需要当天完成的特急任务，Tiger可以参考的信息很少，比如考勤信息，实施人员任务负载，设备空闲状态等等，他只好按照客户要求接收任务，然后将任务分派给实施人员并告知紧急程度。</div>
    <div class="p">然而当客户来取任务结果的时候，Tiger发现实施人员把普通任务完成了，而紧急任务没有做，客户非常不满向经理投诉，Tiger受到了经理的批评。</div>
    <div class="p"><b>现状三：</b>Lion是任务的实施人员，在他手里已经有十几张派工单，里面夹杂着不同紧急程度的任务，完成日期也不一样，每个任务需要完成的时间也不一样，Lion感到很苦恼，他不知道应该如何对工单进行排序。</div>
    <div class="p">此外，当紧急任务完成时，他会需要很多精力重新开始进行之前被中断的任务。每次出现漏掉的紧急任务后，Lion都会陷入深深的自责。</div>
    <div class="p"><b>现状四：</b>May是一名公司经理，她发现项目返工已经严重影响了项目进度，经过对几个发生返工项目的调查研究，发现不规范的工作流程是造成返工的主要原因，经过团队的头脑风暴，一系列针对不同类型项目的工作流程被制定出来。</div>
    <div class="p">然而在项目执行过程中，制定好的工作流程并没有被很好的执行，项目返工的问题依旧存在，这让May一直感到苦恼。</div>
    <div ref="client" class="pb"><b>让我们分别在四个主体上应用“蔡格尼克效应”，他们是客户、项目负责人、项目实施人、项目经理。</b></div>
    <hr>
    <a class="h2">客户为什么会询问？</a>
    <p></p>
    <div class="p">作为上游企业的客户在业务外包以后，第三方服务商企业常常会收到客户对项目进展的询问。客户将业务外包以后，外包部分的业务仍然作为主体项目的一部分，客户会定期或不定期询问外包业务进展状况，当客户可以从外包企业获得明确而肯定的答复，无论业务是否完成，这项外包业务将不会继续占据客户的思维资源。</div>
    <div ref="master" class="p">相反，一旦客户没有得到明确的答复，外包的业务将会始终占据客户的思维资源，客户会增加询问的频率，外包企业会增加越来越多的询问压力，尽管这种询问和回答对项目的进展不会带来任何实质性帮助。</div>
    <div ref="implement" class="h2">项目负责人为什么会崩溃？</div>
    <div class="p">当一个项目负责人需要同时管理7个以上的项目，一旦不能将每一个项目妥善安排，结果必然会同时占用大脑的有限资源，那么这位负责人面临崩溃的状态也就不足为奇了。</div>
    <div class="h2">项目实施人员为什么会出现实施问题？</div>
    <div ref="manager" class="p">实施人员面对手中的派工单，他既要承受完成任务的压力，还要对派工单进行比较分析来进行排序，直到多次决定耗尽了意志，犯错就不可避免。</div>
    <div class="h2">公司经理是否应该规范工作流程？</div>
    <ul ref="improve" class="circle">
    <li>统一规范的工作流程可以避免项目实施人员因为工作流程消耗额外的精力</li>
    <li>统一的工作流程可以让实施人员可以避免意外的漏项</li>
    <li>统一的工作流程可以保证项目实施的一致性</li>
    <li>统一的工作流程可以实现不断的优化</li>
    </ul>
    <div class="p">我们可以看出问题不在于是否应该规范工作流程，May遇到的问题根源在于缺少一个合适的工具或者方法去实施</div>
    <hr>
    <div class="pb"><b>我们来看一下阿敦软件是如何帮助企业能够改善状况。</b></div>
    <div class="h3">明确而清晰回答客户对于项目的询问。</div>
    <div class="p">跟踪系统可以实现对业务所关联的任何字段进行模糊查询这样为客户提供详尽的服务状态。和内部项目的管理控制。</div>
    <img src="../../static/assets/image/project.png"/>
    <div class="p">如图所示，我们在工作流的基础上增加了一个项目维度，从图示中我们可以看到跟踪系统会同时跟踪多个项目，在每一个项目中都会有多个任务，每一个任务都对应一个单独的工作流程。同时也对应着一个工作计划。</div>
    <div class="p">面对客户对于项目的询问，可以从容地在阿敦软件中查找到该项目，除了迅速了解该项目的各项信息，系统还能提供该项目当前状态，所处加工部门，是否可以按期完成等等，使客户可以充分掌握外包项目进展情况。</div>
    <div class="h2">项目负责人妥善安排多个项目任务。</div>
    <ul  class="circle">
      <li>阿敦软件提供了项目信息填写统一入口，信息填写完成以后，相应的流转表，派工单都会根据填写的信息自动生成，</li>
      <li>内嵌考勤管理系统，高效集成考勤信息，并以此来作为任务分配根据之一。</li>
      <li>考勤管理系统可以自定义假期，支持调休，自定义上下班时间，可以为人力资源部生成考勤表。</li>
      <li>系统支持两种工作流，任意流转和预定义流转，可以为任务指定流转方式。</li>
      <li>每项任务可以制定工作计划，该计划可以用来衡量任务是否处于超期状态。</li>
    </ul>
    <div class="p">通过以上工具支持，简化了项目负责人项目信息收集任务，协助项目负责人快速分配任务，并对任务进行有效跟踪。</div>
    <div class="h2">项目实施人员高效，准确，及时完成项目任务。</div>
    <ul  class="circle">
      <li>系统支持项目紧急程度自定义，根据自定义的紧急程度颜色，可以显著区分任务的紧急状态，实现系统的看板功能。</li>
      <li>系统支持细化到个人的待完成事项功能，项目实施人员通过查看待完成事项页面，可以直接确定任务的完成次序。</li>
    </ul>
    <div class="h2">公司经理不再为统一工作流程而愁眉不展。</div>
    <div class="p">工作流程的预定义功能包含了很多特点：</div>
    <ul ref="principle" class="circle">
      <li>自定义流转节点，用户可以无限制定义工作流的流转节点</li>
      <li>节点支持是否发送邮件设置，是否保留流转至节点的当前工作数据</li>
      <li>节点的工作权限可以进行预先设置，也可以根据特殊任务改变任务实施人员</li>
      <li>工作流可以由任意数量节点构成，提交后可以根据配置自动流转至下一个节点</li>
      <li>工作流支持回退，回退的任务自动流转回该任务提交人员，也支持改变为其他任务实施人员。</li>
    </ul>
    <div class="p">通过使用软件可以使统一工作流程的过程变得更加平滑，工作流程的优化也可以通过后台配置实现，从而对员工保持透明。May现在的工作重心终于可以放在优化工作流程，并最终降低项目的返工率。</div>
    <hr>
    <div class="h2">阿敦软件在功能开发原则上坚持的宗旨：</div>
    <div class="p">刚好够用，尽量剔除可以不需要的功能，在够用的基础上不断进行优化，这个宗旨受埃隆马斯克的启发。</div>
    <div class="p"><a href="https://v.163.com/static/1/VGFKQNIVS.html" target="_blank">Musk的工程哲学：</a></div>
    <ul>
      <li>让要求不愚蠢，因为一些要求是绝对愚蠢的，而来自谁并不重要。如果一个聪明人向提出要求，那会特别危险，因为人们可能很少提出质疑。每个人都有错的时候。所有设计都是错的，只是错的程度的问题。</li>
      <li> 尽量删减零件或过程</li>
      <li>简化和改进设计</li>
      <li>加快周转时间</li>
      <li>自动化</li>
    </ul>
    <div class="h2">对应到阿敦软件特点：</div>
    <div class="p">仅限于web开发，避免app开发，考虑到一般app开发需要iphone版和安卓版，相当于节省2/3开发费用。web开发的另一个优点在于统一部署，更加适合多功能软件需求，可以进行用户无感功能升级。web程序不受应用商店限制，同时避免手机操作系统升级导致的应用程序被动升级。</div>
    <div class="p">尽量保持可配置性，用以减少因用户需求改变或增加引起的二次开发。</div>
    <div class="p">系统模块式开发，每一个模块之间保持独立，可以针对不同用户采用不同模块组合，使系统最大程度符合客户需求，又避免为客户单独开发模块，以降低软件费用。</div>
    <div class="p">系统独特的使用面向对象数据库MongoDB，这样客户企业不需要有专门数据库管理员，减少企业软件投资。</div>
    <div class="p">内嵌快速开发工具，对于客户的特殊需求可以利用快速开发工具生成生产代码。</div>
  </div>
</template>
<script>
import json from '@/components/json/content.json'
export default {
  name: 'valueView',
  data () {
    return {
      contents: json.topics
    }
  },
  methods: {
  },
  activated () {
    if (this.$route.params.id !== undefined) {
      let id = this.$route.params.id
      this.$refs[id].scrollIntoView()
    }
  }
}
</script>
<style scoped>
#appMain {
		font-size: 62.5%;
		font-family: Tahoma, "Lucida Grande", Arial, Helvetica, sans-serif;
		color: #102536;
		max-width: 760px;
		min-height: 100%;
		margin: auto;
	}
	.title {
		font-size: 2.4em;
		color: #14556b;
		margin-top: 1em;
		margin-bottom: 15px;
	}
	.h2 {
		font-size: 2em;
		margin-bottom: 15px;
		color: #993;
	}
	a.h2 {
		font-size: 2em;
		margin-bottom: 15px;
		color: #993;
	}
	.h3 {
		font-size: 2em;
		color: #993;
		margin-bottom: 5px;
	}
	.p {
	 font-size: 1.5em;
	 line-height: 150%;
	 text-indent: 2em;
	 margin-top: 10;
	 margin-bottom: 10px;
	}
	.pb {
	 font-size: 2em;
	 line-height: 150%;
	 margin-top: 10;
	 margin-bottom: 10px;
	}
	li {
	 font-size: 1.5em;
	 line-height: 150%;
	 margin-top: 10;
	 margin-bottom: 10px;
	}
  ul.circle {list-style-type:square}
	.code {
	 font-size: 1.2em;
   color:blanchedalmond;
   background-color: #14556b;
	 line-height: 150%;
	 text-indent: 2em;
	 margin-top: 0;
	 margin-bottom: 5px;
	}
  .byline {
  color: #73afb7;
  font-size: 1.5em;
  margin-bottom: 10px;
  font-weight: bold;
  letter-spacing: 1px;
  font-variant: small-caps;
  text-indent: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ValueView.vue